import { Component, Input, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
    selector: 'app-speed-of-light',
    templateUrl: './speed-of-light.component.html',
    styleUrls: ['./speed-of-light.component.scss'],
})
export class SpeedOfLightComponent implements OnInit {
    @Input() i18nHeading: string;
    @Input() items: [{ image: string; i18nKey: string }];

    customOptions: OwlOptions = {
        autoplay: false,
        loop: false,
        mouseDrag: false,
        touchDrag: true,
        pullDrag: false,
        dots: true,
        navSpeed: 700,
        navText: ['', ''],
        responsiveRefreshRate: 250,
        responsive: {
            0: {
                items: 1,
            },
            400: {
                items: 1,
            },
            740: {
                items: 5,
            },
            940: {
                items: 5,
            },
        },
        nav: false,
    };

    constructor() {}

    ngOnInit(): void {}
}
